module.exports = __webpack_public_path__ + "static/launch-002e232707c5a11e73a9b0c68c36a27c.png";